import { IAction } from "../../../redux/actions";

export enum types {
  SHOW_ACTIVITY = "SHOW_ACTIVITY",
  HIDE_ACTIVITY = "HIDE_ACTIVITY"
}

export const showActivity = (): IAction => {
  return {
    type: types.SHOW_ACTIVITY
  };
};

export const hideActivity = (): IAction => {
  return {
    type: types.HIDE_ACTIVITY
  };
};
